import React from 'react';
import styled from 'styled-components';
import { Text } from '@cko/primitives';
const Title = styled(Text) `
  margin: var(--layout-soybean) var(--layout-sandgrain) var(--layout-sandgrain);
  padding: var(--layout-soybean) var(--layout-stamp);
`;
const List = styled.ul `
  list-style-type: none;
  padding: var(--layout-sandgrain) var(--layout-stamp);
  margin: var(--layout-sandgrain);
`;
export const ExampleList = ({ title, examples }) => {
    if (!examples.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Title, null, title),
        React.createElement(List, null, examples.map((example) => {
            return (React.createElement("li", { key: example },
                React.createElement(Text, null, example)));
        }))));
};
